import { render, staticRenderFns } from "./AnaliseSugestao.vue?vue&type=template&id=11db2f83&scoped=true"
import script from "./AnaliseSugestao.vue?vue&type=script&lang=js"
export * from "./AnaliseSugestao.vue?vue&type=script&lang=js"
import style0 from "./AnaliseSugestao.vue?vue&type=style&index=0&id=11db2f83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11db2f83",
  null
  
)

export default component.exports